import { Image } from '@emico-react/image'
import { t } from '@lingui/macro'
import classNames from 'classnames'

import styles from './AccountHero.module.scss'
import { useGetCustomer } from '../../customer/getCustomer.query'
import HeadingColor from '../../types/HeadingColor'
import Heading from '../../typography/Heading'
import overridable from '../../utils/overridable'

const imageSizes = {
    regularWidth: 610,
    mediumWidth: 460,
    smallWidth: 340,
}

interface Props {
    imageUrl?: string
    withOverlay?: boolean
    headingColor?: keyof typeof HeadingColor
}

export const AccountHero = ({
    imageUrl,
    headingColor = 'dark',
    withOverlay = true,
}: Props) => {
    const { data: customer } = useGetCustomer()

    const heading = t({
        id: 'user.dashboard.header.titlePersonalised',
        message: `Welcome ${customer?.firstname}`,
    })

    return (
        <>
            <div className={styles.stylized}>
                <Image
                    alt=""
                    url={customer?.personalizedImage ?? ''}
                    width={440}
                    height={290}
                    lazy={false}
                    className={styles.mirror}
                />
                <Image
                    alt=""
                    url={customer?.personalizedImage ?? ''}
                    width={440}
                    height={290}
                    lazy={false}
                    className={styles.image}
                />
                <div className={styles.blur} />
                <div className={styles.color} />
                <div className={styles.tlLight} />
                <div className={styles.gradient} />
                <div className={styles.saturation} />
                <div className={styles.header}>
                    <Heading
                        variant="h2"
                        fuss={['pme']}
                        element="h2"
                        color={headingColor}
                    >
                        {heading}
                    </Heading>
                </div>
            </div>
        </>
    )
}

export default overridable('AccountHero')(AccountHero)
